const DRAFT = 'draft';
const ACCEPTED = 'accepted';

export {
  DRAFT,
  ACCEPTED,
};
